import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";

import { ActionButtons, DeleteConfirmationModal } from "@components";
import { ChildForm } from "./ChildForm";

import { ChildType } from "@type/HRM/family";
import { childrenValidation } from "@validations/HRM/employee/familyInfoValidation";

interface ChildPropsType {
  childInfo: ChildType;
  changeChildrenInfo: (data: ChildType) => void;
  removeChildInfo: (childID: number) => void;
  updateChildRequestOngoing: boolean;
  getFamilyInfoRequestOngoing: boolean;
  deleteChildRequestOngoing: boolean;
  isProfileDisabled: boolean;
}

export const Child = ({
  childInfo,
  changeChildrenInfo,
  removeChildInfo,
  updateChildRequestOngoing,
  getFamilyInfoRequestOngoing,
  deleteChildRequestOngoing,
  isProfileDisabled,
}: ChildPropsType) => {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const closeConfirmationModal = () => setIsConfirmationModalOpen(false);

  const methods = useForm<ChildType>({
    resolver: yupResolver(childrenValidation),
    values: childInfo as ChildType,
  });

  const { handleSubmit } = methods;
  const onSubmit: SubmitHandler<ChildType> = (data: ChildType) => {
    changeChildrenInfo(data);
  };

  let isSaving = getFamilyInfoRequestOngoing || updateChildRequestOngoing;
  let isDeleting = getFamilyInfoRequestOngoing || deleteChildRequestOngoing;

  return (
    <FormProvider {...methods}>
      <form className="container" onSubmit={handleSubmit(onSubmit)}>
        {isConfirmationModalOpen && (
          <DeleteConfirmationModal
            isModalOpen={isConfirmationModalOpen}
            action={() => removeChildInfo(childInfo.id)}
            onClose={closeConfirmationModal}
          />
        )}

        <ChildForm id={childInfo.id} isProfileDisabled={isProfileDisabled} />
        <ActionButtons
          isSaving={isSaving}
          isDeleting={isDeleting}
          deleteAction={() => setIsConfirmationModalOpen(true)}
        />
      </form>
    </FormProvider>
  );
};
